import { createFileRoute } from '@tanstack/react-router'
import { redirect } from '@hooks'
import { TERROS_MCP_PATH } from '../../components/appShell/terrosMcpRoute'

const SettingsTerrosMcp = redirect(TERROS_MCP_PATH)

export const Route = createFileRoute('/settings/ai/')({
  component: SettingsTerrosMcp,
})
